import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { PATTERN } from '@common';
import { AuthStore, GatewayCommissioningStore, TransferInstallationFormData } from '@store';
import { ForbiddenEmailValidator } from '../../../../shared/validators/forbidden-email/forbidden-email-validator';

import { EmailFormGroup, OwnerAdministratorForm } from '../transfer-installation.helper';

@Component({
  selector: 'app-owner-administrator-form',
  templateUrl: './owner-administrator-form.component.html',
  styleUrls: ['./owner-administrator-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerAdministratorFormComponent implements OnInit, OnDestroy {
  emailFormGroup: FormGroup<EmailFormGroup>;
  emailPattern = PATTERN.EMAIL;
  isOwnerOfTheInstallationSelected = true;
  private userEmail: string;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() formData: TransferInstallationFormData;
  @Output() ownerAdministratorDataChange: EventEmitter<OwnerAdministratorForm> = new EventEmitter<
    OwnerAdministratorForm
  >();

  constructor(
    public gatewayCommissioningStore: GatewayCommissioningStore,
    private authStore: AuthStore
  ) {}

  ngOnInit(): void {
    this.isOwnerOfTheInstallationSelected = this.formData.isOwnerOfTheInstallationSelected;
    this.authStore.loginId$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((loginId) => (this.userEmail = loginId));

    this.emailFormGroup = new FormGroup<EmailFormGroup>({
      email: new FormControl<string>(this.formData.email, [
        Validators.required,
        Validators.pattern(this.emailPattern),
        ForbiddenEmailValidator(this.userEmail),
      ]),
    });

    this.emitFormData();

    this.gatewayCommissioningStore.transferInstallationLoading$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((transferInstallationLoading) => {
        if (transferInstallationLoading) {
          this.emailFormGroup.disable();
        } else {
          this.emailFormGroup.enable();
        }
      });

    this.emailFormGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((value) => {
      this.gatewayCommissioningStore.setFormData({
        isOwnerOfTheInstallationSelected: this.isOwnerOfTheInstallationSelected,
        email: value.email,
      });

      this.emitFormData();
    });
  }

  onOwnerFunctionToggle(isOwnerOfTheInstallationSelected: boolean): void {
    this.isOwnerOfTheInstallationSelected = isOwnerOfTheInstallationSelected;

    this.onDataFormChanged();
  }

  onDataFormChanged(): void {
    this.gatewayCommissioningStore.setFormData({
      isOwnerOfTheInstallationSelected: this.isOwnerOfTheInstallationSelected,
      email: this.emailFormGroup.controls.email.value,
    });

    this.emitFormData();
  }

  private emitFormData(): void {
    this.ownerAdministratorDataChange.emit({
      isOwnerOfTheInstallationSelected: this.isOwnerOfTheInstallationSelected,
      isEmailFormValid: this.emailFormGroup.valid,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
